
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

import AppButton from '~/components/AppButton.vue'
import storyblok from '~/mixins/storyblok'

const defaults = Object.freeze({
  surname: '',
  name: '',
  mail: '',
  zipCode: '',
  phone: '',
  sujet: '',
  message: '',
  newsletter: false
})

export default {
  name: 'ContactPage',
  components: { AppButton },
  mixins: [storyblok, validationMixin],
  async asyncData({ $db, $storyblok, error, params }) {
    const {
      id,
      title,
      heroPicture,
      newsletterLabel,
      newsletterText,
      sujets
    } = await $storyblok.getStoryBySlug('contact')
    return {
      story: {
        id,
        title,
        heroPicture,
        newsletterLabel,
        newsletterText,
        sujets: sujets.map((s) => s.text)
      }
    }
  },
  data: () => ({
    ...defaults,
    done: false
  }),
  validations: {
    surname: { required },
    name: { required },
    mail: { required },
    zipCode: { required },
    sujet: { required },
    message: { required }
  },
  head() {
    return {
      title: "Contacter Grand'Rue"
    }
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
        )
        .join('&')
    },
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      const { story, done, ...formData } = this.$data
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: this.encode({ 'form-name': 'contact', ...formData })
      })
        .then(() => {
          this.resetData()
          this.done = true
        })
        .catch(() => {
          alert(
            'Une erreur est survenue veuillez remplir le formulaire une nouvelle fois'
          )
          this.resetData()
        })
    },
    resetData() {
      Object.keys(defaults).forEach((key) => {
        this.$data[key] = defaults[key]
      })
    }
  }
}
